import { Alert } from 'reactstrap'
import RichText from 'Shared/RichText/RichText'

const PaymentFormErrors = ({ errors }) =>
  <Alert color="danger" className="mt-4">
    <ul className="m-0 ps-4">
      {Object.values(errors).map(error => (
        <RichText className="text-gray-700" key={error} html={error} tag="li" />
      ))}
    </ul>
  </Alert>

export default PaymentFormErrors
